import React from 'react';
import { Tab } from 'semantic-ui-react';
import {
  groupBy,
  pipe,
  prop,
  find,
  propEq,
  toPairs,
  findIndex,
  clone,
  reduce,
  map,
  addIndex,
  sortBy
} from 'ramda';
import CompetitionsList from './List.js';
import { withNamespaces } from 'react-i18next';

const Competitions = (props) => {
  const {
    activeCompetitionId,
    events,
    activeEventId,
    disabled,
    t
  } = props;

    // TODO filter unpublished!
  const groupByDifficulty = (events, activeEventId) => {
    if (!events || !events.length || !activeEventId) {
      return [];
    }

    return pipe(
      find(propEq('value', activeEventId)),
      prop('competitions'),
      groupBy(prop('difficulty')),
      toPairs,
      sortBy(g => g[0] === 'beginner' ? 0 : g[0] === 'intermediate' ? 1 : 2),
    )(events);
  };

  const getAactiveTabIndex = (groups, competitionId) => {
    const mapIndexed = addIndex(map);

    return pipe(
      clone,
      mapIndexed((g, ix) => {
        return findIndex(propEq('id', competitionId))(g[1]) > -1 ? ix : -1;
      }),
      reduce(Math.max, 0)
    )(groups);
  };

  const groupedCompetitions = groupByDifficulty(events, activeEventId),
        activeTabIx = getAactiveTabIndex(groupedCompetitions, activeCompetitionId);

  return (
    <Tab
      defaultActiveIndex={activeTabIx}
      panes={groupedCompetitions.map(([d, c]) => {
        return {
          menuItem: t('private:addTeam.competitions.difficulty.' + d),
          render: () => 
            <Tab.Pane>
              <CompetitionsList
                data={c}
                disabled={disabled}
                activeCompetitionId={activeCompetitionId}
                onSelect={props.onSelect}
              />
            </Tab.Pane>
        };
      })} />
  );
};

export default withNamespaces('private')(Competitions);



// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Competition/Competitions/index.js